import React from "react";
import ReactDOM from "react-dom/client"; // use react-dom/client for React 18+
import App from "./App";
import "./Styles.scss";
import "maplibre-gl/dist/maplibre-gl.css";
import "./i18n/config"; // Initialize i18n
import { UserProvider } from "src/contexts/UserContext";
import { ApiErrorProvider } from "src/contexts/ApiErrorContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ApiErrorProvider>
      <UserProvider>
        <App />
      </UserProvider>
    </ApiErrorProvider>
  </React.StrictMode>
);
